import { Accordion, styled } from '@mui/material';
import { themeDefaults } from '@youscience/theme';

export const sxStyles = {
  accordionTitle: {
    display: 'flex',
    color: themeDefaults?.palette?.text?.secondary,
  },
  tooltip: {
    display: 'flex',
    alignItems: 'center',

    '& > svg:first-of-type': {
      marginLeft: '0.5rem',
    },
  },
};

export const StyledFilterAccordion = styled(Accordion)(() => ({
  marginBottom: '0.5rem',
  backgroundColor: 'transparent',
  boxShadow: 'unset',

  '&:before': {
    height: 0,
  },

  '.MuiAutocomplete-clearIndicator': {
    display: 'none',
  },
}));
